export default __webpack_public_path__ + "static/media/doc2.cccf0809.png";